<template>
    <div class="cs-custom-report">
        <div class="form-toolbar">
            <el-tabs v-model="activeName" stretch>
                <!-- 表单组件 -->
                <el-tab-pane label="数据源" name="components">
                    <el-form  size="mini" label-position="top" class="field-props" >
                     <el-form-item label="业务模型表" style="height:400px">
                        <TreeSelect
                            ref="treeSelect"
                            :sourceOptions="appModelsOptions"
                            @treeSelectChoose="treeSelectChoose"
                        />
                    </el-form-item>
                    <el-form-item label="关联字段" v-if="fieldList">
                        <el-select v-model="selectFields" placeholder="请选择" multiple>
                            <el-option
                                v-for="item in fieldList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            />
                        </el-select>
                    </el-form-item>
                    </el-form>
                </el-tab-pane>
                <!-- 表单字段属性编辑 -->
                <el-tab-pane label="设置主表" name="props" lazy>
                    <el-form  size="mini" label-position="top" class="field-props" >
                        <el-form-item >
                            <el-select  v-model="reportData.mainModelId" placeholder="请选择主表"  @change="handleMainModelChange">
                                <el-option
                                    v-for="item in reportData.modelSources"
                                    :key="item.id"
                                    :label="item.label"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>
            </el-tabs>
        </div>

        <!-- 1.先从左侧的数据源列表选择数据源，2.设置主表，然后再到右边：3.配置表关联关系，4.显示的报表字段，5.查询报表的条件 然后完成设置。 -->
        <div class="form-content">
            <div class="reportIntroduce">
                <el-popover
                    placement="bottom-start"
                    title="生成报表步骤："
                    width="185"
                    trigger="hover"
                    content="1.先从左侧的数据源列表选择数据源，2.设置主表，然后再到右边：3.配置表关联关系，4.显示的报表字段 然后完成设置。">
                    <el-button slot="reference">使用说明</el-button>
                </el-popover>
            </div>
          <CsCustomReportConfig
                :modelData="this.modelData"
                :modelSources="this.reportData.modelSources"
                :referenceFields="this.reportData.referenceFields"
                :selectedTableColumns="this.reportData.selectedTableColumns"
                :conditionFields="this.reportData.conditionFields"
                :selectViewFields="this.reportData.selectViewFields"
                @setTableColumns="setTableColumns"
          />
            <!-- 表单生成测试 -->
            <!-- <div style="max-width: 500px; width: 100%; border: 1px solid #ececec;" v-if="fields.length > 0">
                <el-button type="primary" @click="handleRefreshForm" style="width: 100%;">动态生成表单测试。点击「 刷新 」表单</el-button>
                <RenderForm v-if="isShow" :fields="fieldsList" @formSubmit="handleSubmit"/>
            </div> -->
        </div>
    </div>
</template>

<script>
    import CsCustomReportConfig from '@/components/CsCustomReportConfig';
    import TreeSelect from '@/components/TreeSelect';
    import { getApplicationModelTreeListFromStore, getFormConfigFromStore } from '@/data-model';

    export default {
        components: {
            CsCustomReportConfig,
            TreeSelect
        },
        data () {
            return {
                isShow: true, // 临时测试
                activeName: 'components', // 属性编辑区域，默认选中的tab
                selectedField: undefined, // 正在编辑的字段对象
                dataTable: [],
                modelId: '',
                formId: '',
                fieldList: undefined,
                appModelsOptions: [],
                openDirection: 'top'
                // selectViewFields:[]
            };
        },
        props: {
            fieldsList: {
                type: Array,
                default: () => { return []; }
            },
            reportData: {
                type: Object
            },
            modelData: {
                type: Object
            }
        },
        created () {
            this._initPage();
        },
        methods: {
            async _initPage () {
                this.isShow = false;
                let modelTree = await getApplicationModelTreeListFromStore({
                    currentPage: 1,
                    pageSize: 100,
                    state: 1,
                    modelType: 0,
                    aopModelType: 1
                });
                this.appModelsOptions = modelTree;
                this.isShow = true;
                let selectedTree = [];
                this.reportData.modelSources.forEach((item) => {
                    selectedTree.push(item.id);
                });
                this.$refs.treeSelect.initParam(selectedTree);// 初始化当前报表关联的业务模型
                this.setColumns();
            },
            setColumns () {
                let columns = [];
                this.reportData.selectedTableColumns.forEach((item) => {
                    columns.push(item.prop);
                });
                this.reportData.selectViewFields = columns;
            },
            _setDefaultModel () {
                let formId = this.formId;
                if (formId) {
                    this.getFormModel(formId);
                }
            },
            async getFormModel (formId) {
                const { fieldsList } = await getFormConfigFromStore(formId);
                this.fieldList = fieldsList;
            },
            handelChangeModel (modelId) {
                let selectModel = this.dataTable.filter(item => {
                    return item.id === modelId;
                });
                // console.log(selectModel);
                if (selectModel.length > 0) {
                    this.selectFields = [];
                    this.formId = selectModel[0].formId;
                    this.getFormModel(selectModel[0].formId);
                }
            },
            handleSelectItem (item) {
                this.selectedField = item;
                this.activeName = 'props';
            },
            handleSubmit (formData) {
                // console.log(JSON.stringify(formData, null, 2));
            },
            handleDeleteItem (index) {
                this.fieldsList.splice(index, 1);
            },
            handleRefreshForm () {
                // console.log('刷新表单');
                this.isShow = false;
                this.$nextTick(() => {
                    this.isShow = true;
                });
            },
            treeSelectChoose (selected) { // 选择好数据源后
                if (selected) {
                    this.reportData.modelSources = selected;// 业务模型数据源
                    if (this.reportData.modelSources.length === 0) {
                        this.reportData.mainModelId = '';// 主表字段
                        this.reportData.referenceFields = [];
                        this.reportData.selectViewFields = [];
                        this.reportData.selectedTableColumns = [];
                        this.reportData.conditionFields = [];
                    }
                }
                //  console.log(this.reportData.modelSources);
                //  console.log(selected);
            },
            handleMainModelChange (id) {
                // console.log(id);
                // console.log(this.reportData.mainModelId);
            },
            setTableColumns (columns) {
                this.reportData.selectedTableColumns = columns;
                this.setColumns();
            }
        }
    };
</script>

<style lang="less">
    @import url('./cs-custom-report');
    .cs-custom-report {
        flex: 1;
        border-top: 1px solid #ececec;
        display: flex;

        .form-toolbar {
            width: 180px;
            // padding: 20px 0;
            border-right: 1px solid #ececec;
            overflow-y: auto;

            display: flex;
            justify-content: center;
        }

        .form-content {
            flex: 1;
            padding: 20px 3px;

            display: flex;
            flex-direction: column;
            // justify-content: center;
            align-items: center;
            overflow-y: auto;
            position: relative;
            .reportIntroduce {
                position:absolute;
                // border:1px solid red;
                left:10px;
                top:5px;
            }
        }
        .el-tabs {
            flex: 1;
            margin: 0 5px;
        }
        .field-list {
            width: 100%;
            max-width: 500px;
        }
        .form-required {
            color: red;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/CsCustomReport/CsCustomReport.vue